export default __webpack_public_path__ + "static/media/resume.d78f39eb.pdf";